import React, { useEffect, useMemo, useState } from "react";

import api, { handleApi } from "pages/api/api";
import { useAlert } from "pages/context/AlertContext";

import ProjectTable from "pages/components/ProjectTable/ProjectTable";
import DialogObjetivoV2ClientePatamarFaturas from "pages/comercial/objetivosV2/DialogObjetivoV2ClientePatamarFaturas";

import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";

import CircularProgress from "@mui/material/CircularProgress";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Paper from "@mui/material/Paper";

import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";

import Draggable from "react-draggable";

function PaperComponent(props) {
  return (
    <Draggable
      handle="#dialog-objetivo-v2-patamar-clientes-title"
      cancel={'[class*="MuiDialogContent-root"]'}
    >
      <Paper {...props} />
    </Draggable>
  );
}

export default function DialogObjetivoV2PatamarClientes({ open, onClose, idObjetivo, patamar }) {
  const { showAlert } = useAlert();

  const [loading, setLoading] = useState(false);
  const [detalhe, setDetalhe] = useState(null);

  const [openFaturas, setOpenFaturas] = useState(false);
  const [clienteSelecionado, setClienteSelecionado] = useState(null);

  useEffect(() => {
    let ativo = true;

    const carregar = async () => {
      const idobjetivo = Number(idObjetivo || 0);
      const idpatamar = Number(patamar?.idpatamar || 0);

      if (!open || idobjetivo <= 0 || idpatamar <= 0) {
        setDetalhe(null);
        return;
      }

      setLoading(true);
      setDetalhe(null);

      try {
        const [payload, err] = await handleApi(
          api.post("Comercial/SelObjetivoV2PatamarClientes", {
            idobjetivo,
            idpatamar,
          })
        );

        if (!ativo) {
          return;
        }

        if (err) {
          showAlert(err, "error");
          return;
        }

        setDetalhe(payload?.data ?? payload ?? null);
      } finally {
        if (ativo) {
          setLoading(false);
        }
      }
    };

    carregar();

    return () => {
      ativo = false;
    };
  }, [open, idObjetivo, patamar?.idpatamar, showAlert]);

  const columns = useMemo(
    () => [
      {
        Header: "Referência",
        accessor: "refcliente",
        width: 130,
      },
      {
        Header: "Cliente",
        accessor: "cliente",
        width: 260,
      },
      {
        Header: "NIF",
        accessor: "nif",
        width: 130,
      },
      {
        Header: "Potencial",
        accessor: "segmentopotencial",
        width: 100,
        align: "center",
        headerAlign: "center",
      },
      {
        Header: "Segmento N1",
        accessor: "segmenton1",
        width: 130,
      },
      {
        Header: "Segmento N2",
        accessor: "segmenton2",
        width: 130,
      },
      {
        Header: "Segmento N3",
        accessor: "segmenton3",
        width: 160,
      },
    ],
    []
  );

  const rowActions = useMemo(
    () => [
      {
        id: "faturas",
        tooltip: "Ver faturas",
        icon: <InfoOutlinedIcon fontSize="small" />,
        color: "info",
        onClick: (row) => {
          setClienteSelecionado(row);
          setOpenFaturas(true);
        },
      },
    ],
    []
  );

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="xl"
      fullWidth
      PaperComponent={PaperComponent}
      PaperProps={{
        sx: {
          width: {
            xs: "calc(100vw - 24px)",
            sm: "94vw",
            lg: 1360,
          },
          maxWidth: "calc(100vw - 24px)",
        },
      }}
    >
      <DialogTitle id="dialog-objetivo-v2-patamar-clientes-title" sx={{ cursor: "move" }}>
        Clientes do patamar
      </DialogTitle>

      <DialogContent dividers>
        {loading ? (
          <MDBox py={4} display="flex" justifyContent="center">
            <CircularProgress size={28} />
          </MDBox>
        ) : detalhe ? (
          <>
            <MDBox mb={2}>
              <MDTypography variant="button" color="text" display="block">
                {detalhe?.patamar?.nome || ""}
              </MDTypography>

              <MDTypography variant="caption" color="text" display="block" mt={0.5}>
                Clientes que atingiram este patamar: {detalhe?.total_clientes ?? 0}
              </MDTypography>
            </MDBox>

            <ProjectTable
              tableKey={`objetivos-v2-patamar-clientes-${detalhe?.patamar?.id || "x"}`}
              version="v1"
              columns={columns}
              data={detalhe?.clientes || []}
              rowActions={rowActions}
              actionsPosition="left"
              emptyMessage="Sem clientes para apresentar."
              minWidth={1220}
              maxHeight="60vh"
              showKeepFilters
            />
          </>
        ) : null}
      </DialogContent>

      <DialogActions>
        <MDButton color="secondary" onClick={onClose}>
          Fechar
        </MDButton>
      </DialogActions>

      <DialogObjetivoV2ClientePatamarFaturas
        open={openFaturas}
        onClose={() => {
          setOpenFaturas(false);
          setClienteSelecionado(null);
        }}
        idObjetivo={idObjetivo}
        patamar={patamar}
        cliente={clienteSelecionado}
      />
    </Dialog>
  );
}
